/* eslint-disable */
import PropTypes from 'prop-types';
import ThemeStatePropTypes from '../../State/Store/Theme/Theme.props';

const OrderPagePropTypes = {
  /**
   * The JSS classes to use
   */
  classes: ThemeStatePropTypes.classes.isRequired,

  /**
   * The `id` of the order to display on this page
   */
  orderId: PropTypes.string.isRequired,

  /**
   * The JSS theme to use
   */
  theme: ThemeStatePropTypes.theme.isRequired,
};

export default OrderPagePropTypes;
